'use client';

import { c as _c } from "react/compiler-runtime";
import type { FundingMethod } from '@morfi/onramp-sdk';
import { useTranslations } from 'next-intl';
export function useFundingBankSubtitles() {
  const $ = _c(13);
  const t = useTranslations("onramp");
  let t0;
  if ($[0] !== t) {
    t0 = t("bank_subtitle.sepa");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("bank_subtitle.gbp_bank_transfer");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("bank_subtitle.gbp_open_banking_payment");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("bank_subtitle.pix_instant_payment");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t0 || $[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t4 = {
      sepa: t0,
      gbp_bank_transfer: t1,
      gbp_open_banking_payment: t2,
      pix_instant_payment: t3
    };
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}
export function useFundingMethodLabels() {
  const $ = _c(34);
  const t = useTranslations("onramp");
  let t0;
  if ($[0] !== t) {
    t0 = t("apple_pay");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("google_pay");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("card");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("paypal");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("venmo");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t("revolut_pay");
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("moonpay_balance");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("sepa");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t("gbp_bank_transfer");
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t("gbp_open_banking_payment");
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t("pix_instant_payment");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t0 || $[23] !== t1 || $[24] !== t10 || $[25] !== t2 || $[26] !== t3 || $[27] !== t4 || $[28] !== t5 || $[29] !== t6 || $[30] !== t7 || $[31] !== t8 || $[32] !== t9) {
    t11 = {
      apple_pay: t0,
      google_pay: t1,
      card: t2,
      paypal: t3,
      venmo: t4,
      revolut_pay: t5,
      moonpay_balance: t6,
      sepa: t7,
      gbp_bank_transfer: t8,
      gbp_open_banking_payment: t9,
      pix_instant_payment: t10
    };
    $[22] = t0;
    $[23] = t1;
    $[24] = t10;
    $[25] = t2;
    $[26] = t3;
    $[27] = t4;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  return t11;
}